import CircularProgress from '@mui/material/CircularProgress';
import { Button } from '@src/common/components/button/Button';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: () => void;
  confirm?: () => void;
  closeLabel?: string;
  confirmLabel?: string;
  closeIcon?: ReactNode;
  confirmIcon?: ReactNode;
  confirmDisabled?: boolean;
  confirmLoading?: boolean;
  isSubmitType?: boolean;
};

export const CloseConfirm = ({
  onClose,
  confirm,
  closeLabel,
  confirmLabel,
  closeIcon,
  confirmIcon,
  confirmDisabled,
  confirmLoading,
  isSubmitType,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap={theme.spacing['5']} justifyContent="flex-end">
      <Button variant="outlined" onClick={onClose}>
        {closeIcon ?? <></>}
        {closeLabel ?? t('close')}
      </Button>
      <Button
        type={isSubmitType ? 'submit' : 'button'}
        variant="contained"
        onClick={confirm}
        disabled={confirmDisabled}
        startIcon={
          confirmLoading ? (
            <CircularProgress size={20} />
          ) : (
            (confirmIcon ?? <></>)
          )
        }
      >
        {confirmLabel ?? t('confirm')}
      </Button>
    </Stack>
  );
};
